import { styled } from "../../../../styles";

export const TitleContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const TitleLeft = styled("div", {
  display: "flex",
  alignItems: "center",
});

// Bordered panel that holds the date label, the month filter bar and the
// appointments table (per design the filter lives inside the panel).
export const Panel = styled("div", {
  position: "relative",

  // No top margin: the panel sits directly under the title row, matching the
  // alerts section's table spacing relative to its "Manage triggers" action.
  // Extra top padding (+8px) gives the date label some breathing room (point A).
  padding: "28px 24px 20px",

  borderRadius: "16px",
  border: "1px solid $gray-50",
  backgroundColor: "$white",
});

// Sits at the top-right of the section (outside the panel), matching the
// "Manage triggers"/"Send message" actions on the other patient-page sections.
export const CreateAppointmentContainer = styled("div", {
  color: "$charcoal",
  fontWeight: "600",
  fontSize: "12px",
  lineHeight: "17px",
  cursor: "pointer",

  position: "absolute",
  top: "8px",
  right: "10px",

  borderRadius: "6px",
  padding: "0 2px",

  "&:hover": {
    color: "var(--colors-portal-small-add-button-hover)",
  },
});

// Lets the table (its zebra rows) span the full panel width by cancelling the
// panel's 24px horizontal padding, so there's no white gap at the row edges.
// The date label and filter above keep the panel padding.
export const TableBleed = styled("div", {
  margin: "0 -24px",
});

export const Subtitle = styled("h2", {
  marginBottom: "12px",
  // Nudge the date text in ~2px so it lines up with the filter bar below.
  marginLeft: "2px",

  color: "$gray-80",

  fontWeight: 400,
  fontSize: "12px",

  lineHeight: "16px",
});
